export default {
    clientId: 'ire1nnov2971zh6',
    clientSecret: 'ocryc3l1c3b6i35',
    refreshToken: 'svkniyC8eJgAAAAAAAAAAYOtUkzXsxCg9AxqIBKGcYL5C0xxbKdmtJa8V7ehuQzI'
}